import React, {useContext, useEffect} from 'react';
import {MessagePopupCore, SelectInput, Size, TextArea} from "@dts-soldel/dts-react-common";
import MobXContext from "../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import headerSize from "../../../../../../src/js/misc/headerSize";
import HelpIcon from "../HelpIcon/HelpIcon";
import HelpText from "../HelpIcon/HelpText";

const propTypes = {};
const defaultProps = {};

const HeaderSizeInput = () => {
	const {configuratorStore} = useContext(MobXContext);
	
	useEffect(() => {
		// sanity check that all sizes are known
		if (Object.keys(headerSize).length !== 4) {
			MessagePopupCore.addMessage({
				title: 'Header Sizes list does not match',
				message: 'Not all header sizes accounted for in examples! Please report this to the Utah Header Developers.',
			})
		}
	}, []);

	return (
		<div className="configurator__inputs__input">
			<SelectInput
				size={Size.FULL_WIDTH}
				field="headerSize"
				label="Header Size"
				value={configuratorStore.headerSize}
				onChange={configuratorStore.setFieldValue}
				options={[
					{value: headerSize.SMALL, label: 'Small'},
					{value: headerSize.MEDIUM, label: 'Medium'},
					{value: headerSize.MEDIUM_LARGE, label: 'Medium Large'},
					{value: headerSize.LARGE, label: 'Large'},
				]}
				children={
					<HelpIcon
						popOverText={HelpText.headerSize}
						onUseExampleField="headerSize"
						onUseExampleFieldValue={configuratorStore.setFieldValue}
					/>
				}
			/>
			<TextArea
				size={Size.FULL_WIDTH}
				field="onHeaderResize"
				label="onHeaderResize"
				value={configuratorStore.onHeaderResize}
				onChange={configuratorStore.setFieldValue}
				children={
					<HelpIcon
						popOverText={HelpText.onHeaderResize}
						onUseExampleField="onHeaderResize"
						onUseExampleFieldValue={configuratorStore.setFieldValue}
					/>
				}
			/>
		</div>
	);
};

HeaderSizeInput.propTypes = propTypes;
HeaderSizeInput.defaultProps = defaultProps;

export default observer(HeaderSizeInput);
